import React from 'react';
import moment from 'moment';
import t from '../../../i18n/index';
import './print.scss';

export class AppealPrintVersion extends React.Component {
	render() {
		const { record, fio } = this.props;
		return (
			<div>
				<h1> Государственное Собрание (Ил Тумэн) </h1>
				<h1> Республики Саха (Якутия)</h1>
				<p> Интернет-приемная</p>
				<hr />
				<p>
					<b>Дата поступления обращения:</b> {moment(record.createdAt).format('DD MMMM, YYYY - HH:mm')}{' '}
				</p>
				<p>
					<b>ФИО отправителя:</b> {fio(record)}
				</p>
				<p>
					<b>Email:</b> {record.email}
				</p>
				<p>
					<b>Адрес:</b> {record.address}
				</p>
				<p>
					<b>Контактный телефон:</b> {record.phone}
				</p>
				<p>
					<b>Адресат:</b> {fio(record.deputy)}
				</p>
				<p style={{ textAlign: 'justify' }}>
					<b>Текст сообщения:</b> {record.text}
				</p>
				<p>
					<b>Согласие:</b> {t('agreeText')}
				</p>
			</div>
		);
	}
}
